import {Validator} from './Validator';


const required: Validator = (input: string) => {
  return (input && input.trim().length > 0) ? null : 'Is required';
};

export {required};
